export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-chord/src/constant.js
// module id = ../../../../d3-chord/src/constant.js
// module chunks = 3